/**
 * Generates an array of randomise elements everytime.
 * @param {Array} array - The array to be shuffled.
 * @returns {Array} The shuffled array.
 */
export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};
